import store from '@/store'

/* function checkPermission(el, binding) {
    const { value } = binding

    if (value && value instanceof Array && value.length > 0) {
        const buttons = store.getters && store.getters.buttons
        const permissionButtons = value

        const hasPermission = buttons.some(role => {
            return permissionButtons.includes(role)
        })

        if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    } else {
        throw new Error(`need roles! Like v-permission="['query','add']"`)
    }
} */

function checkPermission(el, binding) {
    const { value } = binding

    if (value && value instanceof Array && value.length > 0) {
        const permissions = store.getters && store.getters.permissions
        const permissionDatas = value
        const all_permission = "*:*:*";

        const hasPermission = permissions.some(permission => {
            return all_permission === permission || permissionDatas.includes(permission)
        })

        if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    } else {
        throw new Error(`need roles! Like v-permission="['query','add']"`)
    }
}

export default {
    inserted(el, binding) {
        checkPermission(el, binding)
    },
    update(el, binding) {
        checkPermission(el, binding)
    }
}
